import { render, staticRenderFns } from "./AssistantsSection.vue?vue&type=template&id=2c30942c"
import script from "./AssistantsSection.vue?vue&type=script&lang=js"
export * from "./AssistantsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports